import { useState } from 'react';

// A remembered choice (a filter or tab), kept on this phone only. Falls back to the
// default when storage is blocked or holds something no longer valid.

export function useStoredChoice<T extends string>(key: string, fallback: T, allowed: readonly T[]): [T, (next: T) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const saved = localStorage.getItem(key);
      return saved && (allowed as readonly string[]).includes(saved) ? (saved as T) : fallback;
    } catch {
      return fallback;
    }
  });
  const set = (next: T) => {
    setValue(next);
    try {
      localStorage.setItem(key, next);
    } catch {
      // Storage blocked: the choice still holds for this visit.
    }
  };
  return [value, set];
}
